"use client";

import { initPostHog } from "@/lib/posthog.client";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    const posthog = initPostHog();

    posthog.captureException(error, {
      digest: error.digest,
      source: "app-error-boundary",
    });
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-gray-900">Something went wrong</h1>
        <p className="text-sm text-gray-500">Please try again in a moment.</p>
      </div>
      <button
        className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white"
        onClick={() => reset()}
        type="button"
      >
        Try again
      </button>
    </div>
  );
}
